// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"159":"caa31000","166":"d118006a","512":"4ac16fb5","726":"6ee00923"}[chunkId] + ".chunk.js";
};